var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M14.75 15.893a.683.683 0 01-.688.678H9.939a.683.683 0 01-.688-.678v-2.036H1v6.107C1 21.05 1.962 22 3.063 22h17.875c1.1 0 2.062-.95 2.062-2.036v-6.107h-8.25v2.036zm6.188-8.822H17.5V5.036C17.5 3.95 16.538 3 15.437 3H8.564C7.463 3 6.5 3.95 6.5 5.036V7.07H3.062C1.962 7.07 1 8.02 1 9.106V12.5h22V9.107c0-1.086-.962-2.036-2.063-2.036zm-6.188 0h-5.5V5.714h5.5v1.357z"
  }))));
}

export default SvgBriefcase;